export default {
  'SCHEDULE' (state) {
    return state.schedule
  },
  'SCHEDULES' (state) {
    return state.schedules
  }
}
